export const MILLIS_IN_DAY: number = 86400000;
export const MILLIS_IN_HOUR: number = 3600000;
export const MILLIS_IN_MINUTE: number = 60000;
export const MILLIS_IN_SECOND: number = 1000;
